import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const requestWarrantyMutation = graphql(
  gql`
    mutation warrantyProgramRequest($warrantyObject: WarrantyObject!) {
      warrantyProgramRequest(warrantyObject: $warrantyObject) {
        message
      }
    }
  `,
  { name: 'requestWarranty' }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/WarrantyProgram/data.ts